import React, { FC, useState, useEffect } from 'react';
import { InputNumber } from 'antd';

interface MinMaxInputProps {
  value?: string; // e.g., "1000-5000"
  onChange?: (value: string) => void;
}

export const MinMaxInput: FC<MinMaxInputProps> = ({ value = '', onChange }) => {
  const [min, setMin] = useState<number | undefined>();
  const [max, setMax] = useState<number | undefined>();

  const parseRange = (range: string) => {
    const [parsedMin, parsedMax] = range.split('-').map(Number);
    return [parsedMin || undefined, parsedMax || undefined];
  };

  useEffect(() => {
    const [parsedMin, parsedMax] = parseRange(value);
    setMin(parsedMin);
    setMax(parsedMax);
  }, [value]);

  const handleMinChange = (val: number | null) => {
    const newMin = val || undefined;
    setMin(newMin);
    onChange?.(`${newMin || ''}-${max || ''}`);
  };

  const handleMaxChange = (val: number | null) => {
    const newMax = val || undefined;
    setMax(newMax);
    onChange?.(`${min || ''}-${newMax || ''}`);
  };

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <InputNumber
        placeholder="Min"
        value={min}
        onChange={handleMinChange}
        min={1000} // Ensure value constraints if required
        style={{ width: '100%' }}
      />
      <InputNumber
        placeholder="Max"
        value={max}
        onChange={handleMaxChange}
        min={1000}
        style={{ width: '100%' }}
      />
    </div>
  );
};
